/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type BankPaginatedProperty =
  typeof BankPaginatedProperty[keyof typeof BankPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BankPaginatedProperty = {
  LEGAL_NAME: 'LEGAL_NAME',
  TRADING_NAME: 'TRADING_NAME',
  ACTIVE_PRODUCTS: 'ACTIVE_PRODUCTS',
  DEPOSITS: 'DEPOSITS',
  COUNTRY: 'COUNTRY',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  CONTACT_NAME: 'CONTACT_NAME',
  END_OF_DAY: 'END_OF_DAY',
  TIME_ZONE_CODE: 'TIME_ZONE_CODE',
  INTEGRATION_TYPE: 'INTEGRATION_TYPE',
  PROTECTION_SCHEME: 'PROTECTION_SCHEME',
  CURRENT_STATE: 'CURRENT_STATE',
} as const;
